/* import __COLOCATED_TEMPLATE__ from './buyer-credits.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { absoluteStoryhunterUrl } from 'sh-www/utils/url';

const CLASS_NAME = 'SH-c-reports-buyer-credits';

class BuyerInvoicesReport extends Component {
  @service constants;
  @service session;

  get className() {
    return CLASS_NAME;
  }

  get isShAdminViewing() {
    return this.session.currentUser.isAdmin;
  }

  get factoidsMap() {
    return this.args.creditFactoids.reduce((accum, factoid) => {
      accum[factoid.title] = factoid.fact;
      return accum;
    }, {});
  }

  @action
  handleDownloadAllCSVPaid(company) {
    window.open(absoluteStoryhunterUrl(`/companies/${company.id}/sh-general-invoices/csv?is_paid=true`));
  }

  @action
  handleDownloadAllCSVUnpaid(company) {
    window.open(absoluteStoryhunterUrl(`/companies/${company.id}/sh-general-invoices/csv?is_paid=false`));
  }

  @task
  *updateDeletedInvoicesPage(page) {
    const {
      shGeneralDeletedInvoices,
      shGeneralDeletedInvoicesPagination,
    } = yield this.args.loadCreditDeletedInvoicesTask.linked().perform(page);

    this.args.updateShGeneralDeletedInvoices(shGeneralDeletedInvoices, shGeneralDeletedInvoicesPagination);
  }

  @task
  *updatePaidInvoicesPage(page) {
    const {
      shGeneralPaidInvoices,
      shGeneralPaidInvoicesPagination,
    } = yield this.args.loadCreditPaidInvoicesTask.linked().perform(page);

    this.args.updateShGeneralPaidInvoices(shGeneralPaidInvoices, shGeneralPaidInvoicesPagination);
  }

  @task
  *updateUnpaidInvoicesPage(page) {
    const {
      shGeneralUnpaidInvoices,
      shGeneralUnpaidInvoicesPagination,
    } = yield this.args.loadCreditUnpaidInvoicesTask.linked().perform(page);

    this.args.updateShGeneralUnpaidInvoices(shGeneralUnpaidInvoices, shGeneralUnpaidInvoicesPagination);
  }
}

export default BuyerInvoicesReport;
